import axios from 'axios';

const STORAGE_KEY = 'forloop_api_unavailable_since';

export const API_MAINTENANCE_WINDOW_MS = 5 * 60 * 1000;

const listeners = new Set();

export function availabilityStatus(downSince, now = Date.now()) {
  if (downSince == null) return 'up';
  if (now - downSince < API_MAINTENANCE_WINDOW_MS) return 'maintenance';
  return 'down';
}

function readSince() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const since = Number(raw);
    if (!raw || !Number.isFinite(since) || since > Date.now() + 5000) return null;
    return since;
  } catch {
    return null;
  }
}

export function getAvailability() {
  const downSince = readSince();
  return { status: availabilityStatus(downSince), downSince };
}

function emit() {
  const next = getAvailability();
  listeners.forEach((listener) => listener(next));
}

export function subscribeApiAvailability(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function markApiDown() {
  if (readSince() == null) {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
      // Ignore storage failures; the in-memory listeners still update on the next successful write.
    }
  }
  emit();
}

export function markApiUp() {
  if (readSince() == null) return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
  emit();
}

export function isApiUnavailableError(error) {
  if (!error || axios.isCancel(error) || error.code === 'ERR_CANCELED' || error.name === 'AbortError') {
    return false;
  }
  const status = error.response?.status;
  if (status === 502 || status === 503 || status === 504) return true;
  return !error.response;
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) emit();
  });
}
